export async function readLimitedFiles(fileList, { maxCount, maxMb = 2, types }) {
  const files = Array.from(fileList || []);
  if (files.length > maxCount) throw new Error(`첨부는 최대 ${maxCount}개까지 가능합니다.`);
  const maxBytes = maxMb * 1024 * 1024;
  const result = [];
  for (const file of files) {
    if (!types.includes(file.type)) throw new Error("허용되지 않는 파일 형식입니다.");
    if (file.size > maxBytes) throw new Error(`파일 1개는 최대 ${maxMb}MB까지 가능합니다.`);
    if (file.type === "application/pdf") {
      const signature = new Uint8Array(await file.slice(0, 5).arrayBuffer());
      if (String.fromCharCode(...signature) !== "%PDF-") {
        throw new Error("유효한 PDF 파일이 아닙니다.");
      }
    }
    result.push({
      name: file.name,
      type: file.type,
      size: file.size,
      raw: file
    });
  }
  return result;
}

export function downloadBlob(filename, blob) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename, rows) {
  const csv = rows
    .map((row) =>
      row
        .map((cell) => `"${String(cell ?? "").replaceAll('"', '""')}"`)
        .join(","),
    )
    .join("\n");
  downloadBlob(
    filename,
    new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }),
  );
}
